<div class="ups-foreman-phase-name-input">
  <input
    #phaseInput
    type="text"
    class="k-textbox w-100 p-2 font-monospace"
    (keydown)="onKeydown($event)"
    (focus)="onFocus($event)"
    (input)="onInput($event)"
    (click)="onClick($event)"
    (paste)="onPaste($event)"
    [attr.maxlength]="displayLen"
    [attr.size]="displayLen"
    spellcheck="false"
    autocomplete="off"
    [disabled]="inputDisabled"
    [attr.title]="'Type to fill each section from the right; sections advance when full. Period (.) moves to the next section.'"
  />
</div>
